import DashboardContent from "../components/DashboardContent/DashboardContent";
import Layout from "../components/Layout/Layout";
import HeroSection from "../components/HeroSection/HeroSection";

const Dashboard = () => {
    return (
        <>
            <Layout>
                <HeroSection />
                <DashboardContent />
            </Layout>
        </>
    )
}

export default Dashboard;